import { render, staticRenderFns } from "./UiMultiSelect.vue?vue&type=template&id=980726b8"
import script from "./UiMultiSelect.vue?vue&type=script&lang=js"
export * from "./UiMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./UiMultiSelect.vue?vue&type=style&index=0&id=980726b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports